import { render } from "./BlackListe.vue?vue&type=template&id=005c4b66"
import script from "./BlackListe.vue?vue&type=script&lang=js"
export * from "./BlackListe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__